export default {"src":"/_next/static/media/icon-learn-center.48ad4e97.svg","height":16,"width":16};